<kendo-window
   [class.failure-mode]="!(isCommunicationHealthy$ | async)"
   #Dialog
   [minWidth]="250"
   [state]="windowState$ | async"
   [(top)]="top"
   [(left)]="left"
   [(height)]="height"
   [(width)]="width"
   (topChange)="topChange($event)"
   (leftChange)="leftChange($event)"
   (heightChange)="heightChange($event)"
   (widthChange)="widthChange($event)"
   (dragStart)="dragStart()"
   (dragEnd)="dragEnd()"
   (resizeStart)="resizeStart()"
   (resizeEnd)="resizeEnd()"
   id="{{ type }}_{{ id }}"
   (stateChange)="onStateChange($event)"
   [style.z-index]="zIndex$ | async"
   (focus)="onFocus()"
   [@windowHideShow]="
      !(isOpen$ | async)
         ? 'window-hidden'
         : {
              value: 'window-shown',
              params: { top: top, left: left, height: height, width: width }
           }
   "
   [@fadeIntoExistance]="isInitialized ? { value: 'open', params: { height: height, width: width } } : 'closed'"
>
   <kendo-window-titlebar>
      <div
         class="title-bar"
         [ngClass]="{
            'mouse-over-title-bar-maximized': (windowState$ | async) === 'maximized',
            'mouse-over-title-bar': (windowState$ | async) !== 'maximized'
         }"
      >
         <div class="title-text sam-center sam-form-flex-row">
            <fa-icon [icon]="titleBarIcon" [fixedWidth]="true" class="window-icon sam-margin-right"></fa-icon>
            <samweb-text-with-overflow-tooltip
               [value]="titleBarHeader"
               class="sam-margin-right sam-hide-overflow"
            ></samweb-text-with-overflow-tooltip>
            <samweb-text-with-overflow-tooltip
               [value]="titleBarAdditionalInfo"
               class="sam-resizeable sam-form-flex-row"
               [ngClass]="{ 'sam-add-brackets': titleBarAdditionalInfo !== '' }"
            ></samweb-text-with-overflow-tooltip>
         </div>
         <div class="title-buttons">
            <button kendoButton *ngIf="(windowState$ | async) !== 'maximized'" (click)="hideWindow()" look="bare">
               <fa-icon class="sam-center" style="font-size: 0.75em" [icon]="WindowHideIcon"></fa-icon>
            </button>
            <button kendoButton *ngIf="(windowState$ | async) !== 'maximized'" (click)="maximizeWindow()" look="bare">
               <fa-icon class="sam-center" style="font-size: 0.75em" [icon]="WindowMaximizeIcon"></fa-icon>
            </button>
            <button kendoButton *ngIf="(windowState$ | async) === 'maximized'" (click)="restoreWindow()" look="bare">
               <fa-icon class="sam-center" style="font-size: 0.75em" [icon]="WindowRestoreIcon"></fa-icon>
            </button>
            <button
               kendoButton
               (click)="onCancelClick()"
               look="bare"
               #closePopupControl
               showOn="none"
               position="bottom"
            >
               <fa-icon class="sam-center" [icon]="WindowCloseIcon"></fa-icon>
            </button>
         </div>
      </div>
   </kendo-window-titlebar>
   <samweb-loading-indicator
      fxFlexFill
      [longRunningContextCategories]="['DIRECTORY_WINDOW', 'EMAIL_WINDOW', 'CHAT_WINDOW']"
      [brickInstanceId]="id.toString()"
      [showLoadingCircle]="true"
   >
      <ng-content></ng-content>
   </samweb-loading-indicator>
</kendo-window>
